export default __webpack_public_path__ + "static/media/grid_1__01.6c3bba11.jpg";